module.exports = ".hx-control-message-component {\n  font-size: 12px;\n  position: absolute;\n  top: 40px;\n  color: #f54336; }\n"